import { jsx as I, Fragment as O, jsxs as b } from "react/jsx-runtime";
import { c as D } from "react/compiler-runtime";
import { useRef as E, useEffect as N } from "react";
import { GoogleMap as k } from "@react-google-maps/api";
import { useMapContext as F } from "./MapContext.js";
import { CircularProgress as J } from "@mui/material";
import U from "./MapAddressInput.js";
import { updateMapWithPlace as W } from "./hooks.js";
import { GOOGLE_MAPS_MAP_ID as $ } from "../../../config/googleMaps.js";
function te(G) {
  const e = D(49), {
    width: n,
    height: _,
    showAddressInput: v,
    children: A,
    options: L
  } = G, {
    center: s,
    zoom: l,
    mapRef: t,
    mapType: i,
    setZoom: p,
    isAPIloaded: g,
    setMapRef: C,
    setCenter: S,
    handleMapTypeChange: Z
  } = F(), R = E(void 0);
  let M;
  e[0] !== t || e[1] !== i ? (M = () => {
    if (t && i) {
      const o = t.getMapTypeId(), j = i.toLowerCase();
      o !== j && t.setMapTypeId(j);
    }
  }, e[0] = t, e[1] = i, e[2] = M) : M = e[2];
  const r = M;
  let T;
  e[3] !== r ? (T = () => {
    r();
  }, e[3] = r, e[4] = T) : T = e[4];
  let x;
  if (e[5] !== s || e[6] !== r || e[7] !== l ? (x = [r, s, l], e[5] = s, e[6] = r, e[7] = l, e[8] = x) : x = e[8], N(T, x), !g && !t) {
    let o;
    return e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ I("div", { style: {
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }, children: /* @__PURE__ */ I(J, {}) }), e[9] = o) : o = e[9], o;
  }
  let a;
  e[10] !== n ? (a = {
    height: "100%",
    width: n,
    display: "flex",
    flexDirection: "column"
  }, e[10] = n, e[11] = a) : a = e[11];
  let m;
  e[12] !== g || e[13] !== t || e[14] !== S || e[15] !== p || e[16] !== v ? (m = v && g && t && /* @__PURE__ */ I(O, { children: /* @__PURE__ */ I(U, { updatePlace: (o) => {
    W(t, o), S(t.getCenter()?.toJSON()), p(t.getZoom());
  } }) }), e[12] = g, e[13] = t, e[14] = S, e[15] = p, e[16] = v, e[17] = m) : m = e[17];
  let f;
  e[18] !== _ || e[19] !== n ? (f = {
    height: _,
    width: n
  }, e[18] = _, e[19] = n, e[20] = f) : f = e[20];
  let w;
  e[21] !== i ? (w = i.toLowerCase(), e[21] = i, e[22] = w) : w = e[22];
  const z = w;
  let d, c;
  e[23] !== C ? (c = (o) => {
    C(o);
  }, d = () => {
    C(void 0);
  }, e[23] = C, e[24] = d, e[25] = c) : (d = e[24], c = e[25]);
  let h;
  e[26] !== i || e[27] !== L ? (h = L || {
    mapTypeControl: !0,
    controlSize: 20,
    clickableIcons: !1,
    mapId: $,
    mapTypeId: i.toLowerCase()
  }, e[26] = i, e[27] = L, e[28] = h) : h = e[28];
  let u;
  e[29] !== r || e[30] !== t || e[31] !== p ? (u = () => {
    const o = t?.getZoom();
    o !== R.current && (o && p(o), R.current = o), r();
  }, e[29] = r, e[30] = t, e[31] = p, e[32] = u) : u = e[32];
  let y;
  e[33] !== s || e[34] !== A || e[35] !== r || e[36] !== Z || e[37] !== d || e[38] !== h || e[39] !== u || e[40] !== f || e[41] !== z || e[42] !== c || e[43] !== l ? (y = /* @__PURE__ */ I(k, { mapContainerStyle: f, center: s, zoom: l, mapTypeId: z, onLoad: c, onUnmount: d, options: h, onZoomChanged: u, onCenterChanged: r, onIdle: r, onMapTypeIdChanged: Z, children: A }), e[33] = s, e[34] = A, e[35] = r, e[36] = Z, e[37] = d, e[38] = h, e[39] = u, e[40] = f, e[41] = z, e[42] = c, e[43] = l, e[44] = y) : y = e[44];
  let P;
  return e[45] !== y || e[46] !== a || e[47] !== m ? (P = /* @__PURE__ */ b("div", { className: "gmap", style: a, children: [
    m,
    y
  ] }), e[45] = y, e[46] = a, e[47] = m, e[48] = P) : P = e[48], P;
}
export {
  te as default
};
